import { Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle, CmsCollection, CmsContentType, CmsPicture, CmsVideo, CmsViewType, Custom } from '@fcom/core-api';
import { AspectRatios } from '@fcom/ui-components/components/images/enums';

@Component({
  selector: 'cms-article-collection',
  templateUrl: './cms-article-collection.component.html',
  styleUrls: ['./cms-article-collection.component.scss'],
  standalone: false,
})
export class CmsArticleCollectionComponent {
  readonly CmsContentType = CmsContentType;
  readonly CmsViewType = CmsViewType;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  readonly aspectRatio = input<keyof typeof AspectRatios>('16x9');
  readonly content = input.required<CmsCollection<CmsPicture | CmsVideo | CmsArticle | Custom>>();
  readonly useGrid = input(true);
  readonly disableTeaserTitle = input(false);
  readonly sectionWrapperClass = input('section pr-large-y');
  readonly sectionClass = input('section-one-third-right pr-xlarge-b');

  readonly articles = computed(() => {
    return new Map(
      this.content()
        .items.filter((item): item is CmsArticle => {
          return item.contentType === CmsContentType.CMArticle;
        })
        .map((article) => {
          return [article.contentId, article];
        })
    );
  });
}
